import React from 'react'

import QAServicingTabsContainer from '../../containers/qa-servicings/qa-servicing-tabs-container'
import { Details, Row, Block } from '../../components/details/details'

export default ({
  qaServicing,
  area,

  loading
}) => {
  if (loading) {
    return <p>Loading...</p>
  }

  return (
    <div className='qa-servicing-details servicing-details'>
      <Details>
        <Row>
          <Block title='room'>
            <p>{area.name}</p>
          </Block>
          <Block title='last cleaned'>
            <p>{
              area.lastCleaned
                ? area.lastCleaned.format('MMMM Do, YYYY, h:mm A')
                : '—'
            }</p>
          </Block>
          <Block title='last cleaning'>
            <p>{(area.lastCleaning || []).join(', ') || '—'}</p>
          </Block>
        </Row>
      </Details>

      <QAServicingTabsContainer qaServicingId={qaServicing.id} areaId={area.id} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/qa-servicings/qa-servicing-details.js